export const formatNumber = (num: number): string => {
  return num.toLocaleString('en-US');
};

export const formatQuantity = (quantity: number): string => {
  if (quantity >= 1000000) {
    return `${(quantity / 1000000).toFixed(1)}M`;
  }
  if (quantity >= 1000) {
    return `${(quantity / 1000).toFixed(1)}K`;
  }
  return quantity.toString();
};
